import { PenLine, Droplets, Shirt, Circle, Lamp, Palette } from "lucide-react";
import { Reveal, Eyebrow } from "./Motion";

const ITEMS = [
  { icon: PenLine, label: "A journal and your favourite pen" },
  { icon: Palette, label: "Simple art supplies — paper, colours, anything at hand" },
  { icon: Circle, label: "A yoga mat, rug or cushion to sit on" },
  { icon: Shirt, label: "Comfortable clothing you can move in" },
  { icon: Droplets, label: "A bottle of water or a warm cup of tea" },
  { icon: Lamp, label: "A quiet corner where you will not be disturbed" },
];

export const Bring = () => (
  <section id="bring" className="py-20 lg:py-32" data-testid="bring-section">
    <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
      <div className="grid grid-cols-1 gap-14 lg:grid-cols-[0.9fr_1.1fr]">
        <Reveal>
          <Eyebrow>Before we begin</Eyebrow>
          <h2 className="mt-5 font-serif text-3xl font-light tracking-tight text-[#262320] sm:text-4xl lg:text-5xl">
            What to bring
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-[#6E6862]">
            Nothing fancy — just a few familiar things to help you feel comfortable and free to create.
          </p>
          <div className="mt-8 rounded-2xl border border-dashed border-[#5E7D6A]/50 bg-[#D6E0D8]/30 p-6">
            <p className="font-serif text-lg italic text-[#262320]">
              "Come as you are. The circle holds the rest."
            </p>
          </div>
        </Reveal>
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          {ITEMS.map((item, i) => (
            <Reveal key={item.label} delay={i * 0.07}>
              <div
                className="flex h-full items-start gap-4 rounded-2xl border border-[#D9C3A3]/50 bg-white/75 p-6 transition-colors duration-300 hover:border-[#5E7D6A]/50"
                data-testid={`bring-item-${i}`}
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#F4E3E0]">
                  <item.icon size={18} className="text-[#5E7D6A]" />
                </span>
                <p className="pt-2 text-sm leading-relaxed text-[#262320]">{item.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
